import Layout from "Layout";
import AffiliateCreator from "pages/AffiliateCreator";
import BrandDesign from "pages/BrandDesign";
import CommunityHome from "pages/CommunityHome";
import CreatorLab from "pages/CreatorLab";
import CreatorStudy from "pages/CreatorStudy";
import Docs from "pages/Docs";

import Home from "pages/Home";
import HowToGetSketch from "pages/HowToGetSketch";
import Landing from "pages/Landing";

import Messenger from "pages/Messenger";
import NewsEvents from "pages/NewsEvents";
import Nft from "pages/Nft";
import SketchDrop from "pages/SketchDrop";
import SketchMessenger from "pages/SketchMessenger";
import SketchPay from "pages/SketchPay";
import SketchWallet from "pages/SketchWallet";
import Support from "pages/Support";
import SupportDetail from "pages/SupportDetail";
import SystemIntegration from "pages/SystemIntegration";
import UseNft from "pages/UseNft";
import UsingPay from "pages/UsingPay";
import UsingWallet from "pages/UsingWallet";
import WhatIsSketch from "pages/WhatIsSketch";

import AdminLayout from "Layout/Admin/AdminLayout";
import AdminHome from "pages/Admin/AdminHome";
import AdminNotice from "pages/Admin/AdminNotice/AdminNotice";
import ModifyNotice from "pages/Admin/AdminNotice/ModifyNotice/ModifyNotice";
import NoticeUpload from "pages/Admin/AdminNotice/NoticeUpload/NoticeUpload";
import Login from "pages/Admin/Login";
import ManageAdmin from "pages/Admin/ManageAdmin";
import ModifyNews from "pages/Admin/News/ModifyNews/ModifyNews";
import NewsHome from "pages/Admin/News/NewsHome";
import UploadNews from "pages/Admin/News/UploadNews";
import Signup from "pages/Admin/Signup";
import UploadImage from "pages/Admin/UploadImage";
import SketchScan from "pages/SketchScan";
import { TermBasicPay } from "pages/Terms/TermBasicPay";
import { TermBasicWallet } from "pages/Terms/TermBasicWallet";
import { TermMarketingPay } from "pages/Terms/TermMarketingPay";
import { TermMarketingWallet } from "pages/Terms/TermMarketingWallet";
import { TermPersonPay } from "pages/Terms/TermPersonPay";
import { TermPersonWallet } from "pages/Terms/TermPersonWallet";
import WhoIsCreator from "pages/WhoIsCreator";
import { useRoutes } from "react-router";
import { SwapLayout } from "Layout/Swap/SwapLayout";
import { Swap } from "pages/Swap/Swap";

const Router = () => {
  const routes = [
    {
      path: "/",
      element: <Landing />,
    },
    {
      path: "/",
      element: <Layout />,
      children: [
        {
          path: "/home",
          element: <Home />,
        },
        {
          path: "how_to_get_sketch",
          element: <HowToGetSketch />,
        },
        {
          path: "sketch_wallet",
          element: <SketchWallet />,
        },
        {
          path: "sketch_pay",
          element: <SketchPay />,
        },
        {
          path: "sketch_messenger",
          element: <SketchMessenger />,
        },
        {
          path: "nft",
          element: <Nft />,
        },
        {
          path: "using_wallet",
          element: <UsingWallet />,
        },
        {
          path: "using_pay",
          element: <UsingPay />,
        },
        {
          path: "messenger",
          element: <Messenger />,
        },
        {
          path: "use_nft",
          element: <UseNft />,
        },
        {
          path: "docs",
          element: <Docs />,
        },
        {
          path: "who_is_creator",
          element: <WhoIsCreator />,
        },
        {
          path: "affiliate_creator",
          element: <AffiliateCreator />,
        },
        {
          path: "creator_study",
          element: <CreatorStudy />,
        },
        {
          path: "creator_lab",
          element: <CreatorLab />,
        },
        {
          path: "system_integration",
          element: <SystemIntegration />,
        },
        {
          path: "brand_design",
          element: <BrandDesign />,
        },
        {
          path: "community_home",
          element: <CommunityHome />,
        },
        {
          path: "news_events/:page",
          element: <NewsEvents />,
        },
        {
          path: "support",
          element: <Support />,
        },
        {
          path: "what_is_sketch",
          element: <WhatIsSketch />,
        },
        {
          path: "sketch_drop",
          element: <SketchDrop />,
        },
        {
          path: "sketch_scan",
          element: <SketchScan />,
        },
      ],
    },
    {
      path: "/support",
      element: <Layout />,
      children: [
        {
          path: ":supportId/:menuIndex",
          element: <SupportDetail />,
        },
      ],
    },
    {
      path: "/admin-sketch",
      element: <AdminLayout />,
      children: [
        {
          path: "",
          element: <AdminHome />,
        },
        {
          path: "login",
          element: <Login />,
        },
        {
          path: "signup",
          element: <Signup />,
        },
        {
          path: "news/manage/:page",
          element: <NewsHome />,
        },
        {
          path: "news/upload",
          element: <UploadNews />,
        },
        {
          path: "news/modify",
          element: <ModifyNews />,
        },
        {
          path: "upload",
          element: <UploadImage />,
        },
        {
          path: "admins/manage/:page",
          element: <ManageAdmin />,
        },
        {
          path: "notices/manage/:page",
          element: <AdminNotice />,
        },
        {
          path: "notices/upload",
          element: <NoticeUpload />,
        },
        {
          path: "notices/modify",
          element: <ModifyNotice />,
        },
      ],
    },

    {
      path: "/term/wallet",
      element: <TermBasicWallet />,
    },
    {
      path: "/payterm/wallet",
      element: <TermBasicPay />,
    },
    {
      path: "/term/personal",
      element: <TermPersonWallet />,
    },
    {
      path: "/payterm/personal",
      element: <TermPersonPay />,
    },
    {
      path: "/term/marketing",
      element: <TermMarketingWallet />,
    },
    {
      path: "/payterm/marketing",
      element: <TermMarketingPay />,
    },
    {
      path: "/swap",
      element: <SwapLayout />,
      children: [
        {
          path: "",
          element: <Swap />,
        },
      ],
    },
  ];
  return useRoutes(routes);
};

export default Router;
